import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RuleItemProps as Props } from './types';

export const RuleItem = memo(({ className, rule }: Props) => {
  const isScreenWide = useMediaQuery('(min-width:1366px)');
  const isFree = rule.credit === 0;
  return (
    <Styled.Wrapper className={classnames('RuleItem', className)} sx={SX.root}>
      <Typography
        variant="body4"
        fontWeight={500}
        color="primary.800"
        noWrap={isScreenWide}
      >
        {rule.title}
      </Typography>

      <Stack sx={SX.creditUsage}>
        <Stack sx={SX.titleWrapper}>
          <Icon name="coin" size={14} />
          {!isFree && <Typography variant="body4">x</Typography>}
          <Typography variant="body4">
            {isFree ? 'Free' : rule.credit}
          </Typography>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

RuleItem.displayName = 'RuleItem';
